import React from "react";
import { cn } from "../../lib/utils";

const STYLES = {
  NEW: "bg-ink text-paper",
  BESTSELLER: "bg-brand text-ink",
  SALE: "bg-paper text-ink border border-ink",
};

const Badge = ({ label, className }) => (
  <span
    className={cn(
      "label-mono px-2.5 py-1 leading-none",
      STYLES[label] || "bg-ink text-paper",
      className
    )}
    data-testid={`badge-${label?.toLowerCase()}`}
  >
    {label}
  </span>
);

export default Badge;
